import React, { useState } from 'react';
import Modal from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import alert from '../../helpers/alert';
import addVinToBlacklist from '../../api/vinBlacklist/addVinToBlacklist';
import importVinBlacklist from '../../api/vinBlacklist/importVinBlacklist';
import {
  ALLOWED_EXTENSIONS,
  SAMPLE_CSV_HREF,
  VIN_LENGTH,
  fileProblem,
  importSummary,
  normalizeVinInput,
} from './vinBlacklistHelpers';
import styles from './addVinModal.module.css';

// Добавление в чёрный список: один VIN вручную или файл. Файл всегда ДОПОЛНЯЕТ список, ничего не заменяет.
// Ошибки бэка (VIN уже в списке и т.п.) показывает общий api.onError.
const AddVinModal = ({ isOpen, onClose, onDone }) => {
  const [mode, setMode] = useState('manual');
  const [vin, setVin] = useState('');
  const [reason, setReason] = useState('');
  const [file, setFile] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const [saving, setSaving] = useState(false);

  const canSubmit = mode === 'manual' ? vin.length === VIN_LENGTH : !!file;

  const pickFile = (picked) => {
    if (!picked) return;
    const problem = fileProblem(picked);
    if (problem) {
      alert.error(problem);
      return;
    }
    setFile(picked);
  };

  const finish = () => {
    setVin('');
    setReason('');
    setFile(null);
    onDone();
  };

  const submit = () => {
    setSaving(true);
    const request = mode === 'manual' ? addVinToBlacklist({ vin, reason: reason.trim() }) : importVinBlacklist([file]);
    request
      .then((res) => {
        alert.success(mode === 'manual' ? 'VIN добавлен' : importSummary(res?.data));
        finish();
      })
      .catch(() => {})
      .finally(() => setSaving(false));
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      title="Добавить в чёрный список"
      overlayStyle={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      contentStyle={{
        position: 'relative',
        inset: 'auto',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '90%',
        maxWidth: 520,
        maxHeight: '90vh',
        overflow: 'auto',
      }}
    >
      <div className={styles.modes}>
        <button
          type="button"
          className={`${styles.mode} ${mode === 'manual' ? styles.modeActive : ''}`}
          onClick={() => setMode('manual')}
        >
          Вручную
        </button>
        <button
          type="button"
          className={`${styles.mode} ${mode === 'import' ? styles.modeActive : ''}`}
          onClick={() => setMode('import')}
        >
          Импорт из файла
        </button>
      </div>

      <div className={styles.body}>
        <div className={`${styles.pane} ${mode === 'manual' ? '' : styles.paneHidden}`}>
          <div className={styles.fields}>
            <Input
              title="VIN"
              placeholder="Укажите VIN"
              maxLength={VIN_LENGTH}
              value={vin}
              handleSetState={(value) => setVin(normalizeVinInput(value))}
            />
            <Input title="Причина" placeholder="Необязательно" value={reason} handleSetState={setReason} />
          </div>
        </div>

        <div className={`${styles.pane} ${mode === 'import' ? '' : styles.paneHidden}`}>
          <label
            className={`${styles.drop} ${dragOver ? styles.dropActive : ''}`}
            onDragOver={(e) => {
              e.preventDefault();
              setDragOver(true);
            }}
            onDragLeave={() => setDragOver(false)}
            onDrop={(e) => {
              e.preventDefault();
              setDragOver(false);
              pickFile(e.dataTransfer.files?.[0]);
            }}
          >
            <span className={styles.dropTitle}>{file ? file.name : 'Выберите файл или перетащите сюда'}</span>
            <span className={styles.dropHint}>{ALLOWED_EXTENSIONS.join(', ')}</span>
            <input
              type="file"
              accept={ALLOWED_EXTENSIONS.join(',')}
              hidden
              onChange={(e) => pickFile(e.target.files?.[0])}
              onClick={(e) => (e.target.value = null)}
            />
          </label>
          <p className={styles.format}>
            Колонки: VIN и Причина (необязательно). VIN из файла добавляются к списку, уже имеющиеся пропускаются,
            ничего не удаляется.{' '}
            <a href={SAMPLE_CSV_HREF} download="vin-blacklist-example.csv">
              Скачать пример
            </a>
          </p>
        </div>
      </div>

      <Button text="Добавить" fill full disabled={!canSubmit || saving} onClick={submit} />
    </Modal>
  );
};

export default AddVinModal;
